import React, { useState } from "react";
import { Grid } from "@mui/material";
import RightPartRegistration from "./rightPartRegistration";
import palette from "../../theme/palette";
import LeftPartLogin from "./leftPartLogin";
import RightPartCodeVerify from "./rightPartCodeVerify";
import { xVersion } from "../../services/config";
import CommonMobileAuthLayout from "./mobile/commonView";
import useWidth from "../../utils/useWidth";

const RegistrationAuth = () => {
  const [codeVerified, setCodeVerified] = useState(xVersion ? true :false)
  localStorage.removeItem("userDetails");
  localStorage.removeItem("userValues");
  localStorage.removeItem("userId");
  localStorage.removeItem("userDate");
  const width = useWidth()
  if (width < 768) {
   return <CommonMobileAuthLayout type="sign_up"/>
  }
  return (
    <Grid
      container
      alignItems="center"
      columns={16}
      sx={{ backgroundColor: palette.common.white }}
    >
      {/* START LEFT SECTION */}
      <Grid item xs={9} className="leftside-menu login-screen">
        <LeftPartLogin />
      </Grid>
      {/* END LEFT SECTION */}

      {/* START RIGHT SECTION */}
      <Grid item xs={7} className="rightside-menu">
        {codeVerified && <RightPartRegistration />}
        {!codeVerified && <RightPartCodeVerify setCodeVerified={setCodeVerified} />}
      </Grid>
      {/* END RIGHT SECTION */}
    </Grid>
  );
};
export default RegistrationAuth;
